import { useState, useEffect } from 'react'
import { OidcClient } from '@axa-fr/oidc-client'
import { useLocation } from 'react-router-dom'
import {
  OPENID_REGISTER_URL,
  OPENID_CLIENT_ID,
  OPENID_REGISTER_REDIRECT_URI,
  OPENID_SCOPE,
} from 'common/constants/env'
import { ERoutes } from 'common/entities/routes'

interface IParamsObject {
  [key: string]: string
}

export const useGetOidcSecureExtrasFromUrl = () => {
  const loc = useLocation()
  const [params, setParams] = useState<IParamsObject>()

  useEffect(() => {
    const queryParams = new URLSearchParams(loc.search)
    const paramsObject: IParamsObject = {}

    queryParams.forEach((key, value) => {
      paramsObject[value] = key
    })
    setParams(paramsObject)
  }, [loc])

  return params
}

/**
 * Helper function to build the OpenID registration URL.
 */
export const buildOpenIdRegistrationUrl = (): string => {
  const baseParams: Record<string, string> = {
    client_id: OPENID_CLIENT_ID,
    redirect_uri: encodeURIComponent(OPENID_REGISTER_REDIRECT_URI),
    scope: encodeURIComponent(OPENID_SCOPE),
    post_signup_uri: encodeURIComponent(
      `${window.location.origin}${ERoutes.ID_MAGALU_LOGIN}${window.location.search}`
    ),
  }

  const searchParams = new URLSearchParams(window.location.search)
  const email = searchParams.get('email')

  if (email) {
    baseParams.email = encodeURIComponent(email)
  }

  const queryString = Object.entries(baseParams)
    .map(([key, value]) => `${key}=${value}`)
    .join('&')

  return `${OPENID_REGISTER_URL}?${queryString}`
}

/**
 * Redirects the user to the OpenID registration page.
 */
export const redirectToIdmRegistrationPage = () => {
  const registrationUrl = buildOpenIdRegistrationUrl()
  window.location.href = registrationUrl
}

export const useRedirectToLogin = () => {
  return (callbackPath: string, extras: Record<string, string>) => {
    // Atualiza a URL sem recarregar a página
    const oidc = OidcClient.get('default')
    oidc.loginAsync(callbackPath, extras)
  }
}
